import React from 'react';
import { useAdminTheme } from '../../contexts/AdminThemeContext';
import ServiceComparison from '../service/ServiceComparison';

const ServiceComparisonPage = () => {
  const { isDarkMode } = useAdminTheme();

  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-skyone-page-dark' : 'bg-gray-50'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className={`text-3xl font-bold transition-colors duration-300 ${
            isDarkMode ? 'text-white' : 'text-gray-900'
          }`}>Airport Meet & Greet Services</h1>
          <p className={`mt-2 text-lg transition-colors duration-300 ${
            isDarkMode ? 'text-gray-300' : 'text-gray-600'
          }`}>
            Compare our premium airport services and find the perfect option for your needs
          </p>
        </div>
        
        <ServiceComparison />
      </div>
    </div>
  );
};

export default ServiceComparisonPage;
